import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';
import { toasts } from '@/utils/toasts';

export const archiveRefuseReason = ({ _id }: { _id: string }): Promise<void> => {
  return axios.post(`/refuse-reasons/${_id}/archive`);
};

type UseArchiveRefuseReasonOptions = {
  config?: MutationConfig<typeof archiveRefuseReason>;
};

const TOAST_ID = 'archive-refuse-reason';

export const useArchiveRefuseReason = ({ config = {} }: UseArchiveRefuseReasonOptions = {}) => {
  return useMutation({
    ...config,
    onSuccess: (...params) => {
      queryClient.invalidateQueries(['refuse-reasons']);
      toasts.loadingToast.success(TOAST_ID, 'Refuse reason archived');
      config.onSuccess?.(...params);
    },
    onError: (error: AxiosError<{ error: string }>, ...args) => {
      const serverMessage = error.response?.data?.error;
      toasts.loadingToast.error(TOAST_ID, serverMessage);
      config.onError?.(error, ...args);
    },
    onMutate: (...args) => {
      toasts.loadingToast.loading(TOAST_ID, 'Archiving...');
      config.onMutate?.(...args);
    },
    mutationFn: archiveRefuseReason,
  });
};
